// extracted by mini-css-extract-plugin
export default {"hover-only":"_28tGR","hoverOnly":"_28tGR","hover-only-and-collapsed":"_2sZ0d","hoverOnlyAndCollapsed":"_2sZ0d","hoverable":"_2H8F7","permanent-icon":"TwS3w","permanentIcon":"TwS3w"};